<template>
  <div class="content">
    <h3 class="title">How many kilometers does it have on it today?</h3>
    <div class="field">
      <label class="label" for="kmDriven">The nearest thousand is ok!</label>
      <input class="input" name="kmDriven" v-model="kms" />
    </div>
    <Question />
    <h3>You drove {{kms}}.</h3>
  </div>
</template>

<script>
import Question from '@/components/question';
let kms = 5;

export default {
  name: 'Questions',
  props: {
    userCar: {
      type: Object,
      default: () => {}, 
    },
  },
  components: { Question },
  data() {
    return {
      Question,
      kms,
    };
  },
  methods: {
    doSomething() {
      //this.userCar = [];
    },
  },
};
</script>